import { AlluLogo } from "@/components/parceiros/AlluLogo";
import { CTAAnchor } from "@/components/parceiros/cta";
import { LiveBadge } from "./LiveBadge";
import { formatSessionShort, getNextSession } from "@/lib/selecao-sessions";

const NAV = [
  { href: "#depoimentos", label: "Depoimentos" },
  { href: "#quem-e-a-allu", label: "Quem é a Allu" },
  { href: "#como-funciona", label: "Como funciona" },
];

export const SelecaoHeader = () => {
  const next = getNextSession();
  const short = formatSessionShort(next.date);

  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur bg-[#FAF8F5]/90 border-b border-zinc-200">
      <div className="container-wide flex items-center justify-between gap-3 py-4">
        <a href="/selecao" aria-label="Allu" className="block shrink-0">
          <AlluLogo variant="dark" className="h-8 sm:h-10 md:h-12 w-auto" />
        </a>

        {/* Nav center — só md+ */}
        <nav className="hidden md:flex items-center gap-5 lg:gap-7 text-sm font-medium text-zinc-600">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="hover:text-[#112711] transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 sm:gap-4">
          <LiveBadge className="hidden xl:inline-flex">{`próxima · ${short}`}</LiveBadge>
          <CTAAnchor
            href="#form"
            variant="primary"
            size="md"
            className="text-sm"
          >
            Reservar vaga
          </CTAAnchor>
        </div>
      </div>
    </header>
  );
};
